module.exports = __webpack_public_path__ + "static/assets/ecb9cc193644c7510559603dfd4d210c.svg";